import {
  Filter,
  ArrayField,
  Datagrid,
  TextField,
  TextInput,
  SelectField,
  SelectInput,
  ReferenceField,
  EditButton,
  DeleteButton,
  BooleanField,
  BooleanInput,
  NumberInput,
  NumberField,
} from "react-admin";

import resources from "../../constants/resources";
import {
  SITES,
  CONTENT_TYPES_LIST,
  KUDZU_SITES,
} from "../../constants/contentConstants";
import { ListStyles } from "../../styles/commonStyles";
import { PP_ADMIN_REFERRER } from "../../constants/storageKeys";

const ContentFilter = props => (
  <Filter {...props}>
    <NumberInput label="ID" source="id" />
    <TextInput label="Name" source="name_i18n" />
    <BooleanInput label="Published" source="is_published" />
    {/* TODO: KD-169 */}
    <SelectInput label="Site" source="sites" choices={
      localStorage.getItem(PP_ADMIN_REFERRER) === KUDZU_SITES[0].title 
        ? KUDZU_SITES 
        : SITES
    } />
   
    <NumberInput label="Topic" source="topic" />
    <SelectInput
      label="Content Type"
      source="content_type"
      choices={CONTENT_TYPES_LIST}
    />
  </Filter>
);

const ContentList = props => (
  <ListStyles
    title={resources.CONTENT.title}
    filters={<ContentFilter />}
    exporter={false}
    perPage={25}
    sort={{ field: "order", order: "ASC" }}
    {...props}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      {/* TODO: KD-169 */}
      <ArrayField source="sites" sortable={false}>
        <Datagrid bulkActionButtons={false}>
          <SelectField
            source="id"
            sortable={false}
            choices={
              localStorage.getItem(PP_ADMIN_REFERRER) === KUDZU_SITES[0].title 
                ? KUDZU_SITES 
                : SITES
            }
            label=""
          />
        </Datagrid>
      </ArrayField>
      <ReferenceField
        label={resources.TOPIC.label}
        source="topic"
        sortable={false}
        reference={resources.TOPIC.url}
      >
        <TextField source="name_en" />
      </ReferenceField>
      <TextField label="Name" source="name_en" sortable={false} />
      <BooleanField
        label="Is Published"
        source="is_published"
        sortable={false}
      />
      <SelectField
        source="content_type"
        sortable={false}
        choices={CONTENT_TYPES_LIST}
      />
      <NumberField source="order" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </ListStyles>
);

export default ContentList;
